export const MEDPLUM_COOKIE_NAME = "medplum";
export const SESSION_EXPIRED_COOKIE_NAME = "vibrant-session-expired";
export const SESSION_CANDIDATE_COOKIE_NAME = "vibrant-session-candidate";
